import Gallery from "../components/Gallery";
import Footer from "../components/Footer";

export default function HomePage () {

  return (
    <>
      <Gallery />
      <Footer />
    </>
  )
}